import { Button } from '../../ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useFormatters } from '../../../contexts/PreferencesContext'

interface WeekPagerProps {
  page: number
  /** First Monday and last Sunday shown (ISO dates). */
  from?: string
  to?: string
  loading?: boolean
  /** CR-1421 decision 1: false on the page holding the period's last week. */
  hasNext?: boolean
  onPageChange: (page: number) => void
}

/** CR-1421: "‹ Previous 12 weeks · range · Next 12 weeks ›" for the Cost weekly charts. */
export function WeekPager({ page, from, to, loading, hasNext = true, onPageChange }: WeekPagerProps) {
  const { formatDate } = useFormatters()
  return (
    <div className="flex items-center gap-1.5 whitespace-nowrap">
      <Button
        variant="outline" size="sm" disabled={page === 0 || loading}
        onClick={() => onPageChange(page - 1)} aria-label="Previous 12 weeks"
      >
        <ChevronLeft className="h-4 w-4" />
        <span className="hidden sm:inline">Previous 12 weeks</span>
      </Button>
      {from && to && (
        <span className="px-1 text-xs text-muted-foreground tabular-nums">
          {formatDate(from)} – {formatDate(to)}
        </span>
      )}
      <Button
        variant="outline" size="sm" disabled={loading || !hasNext}
        onClick={() => onPageChange(page + 1)} aria-label="Next 12 weeks"
      >
        <span className="hidden sm:inline">Next 12 weeks</span>
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
